const locale = {
  NEW: 'Новий',
  TIME: 'Час',
  TRACKER: 'Трекер',
  TYPE: 'Тип',
  TEST: 'Тест',
  LIVE: 'Наживо',
  NAME: 'Назва',
  STYLE: 'Стиль',
  MODE: 'Режим',
  SELFIE: 'Селфі',
  SAVE: 'Зберегти',
  CUSTOM: 'Власний',
  EDIT: 'Редагувати',
  MOBILE: 'Мобільний',
  PALETTE: 'Палітра',
  PERIOD: 'Період',
  DELETE: 'Видалити',
  BUTTON: 'Кнопки',
  COUNTRIES: 'Країни',
  GENERAL: 'Загальні',
  CANCEL: 'Скасувати',
  DUPLICATE: 'Дублікат',
  COMPLETE: 'Завершено',
  CONFIRM: 'Підтвердити',
  AML_CHECK: 'AML перевірка',
  WEB_CAMERA: 'Web камера',
  TYPOGRAPHY: 'Шрифти',
  QUESTIONNAIRE: 'Опитувальник',
  DOCUMENTATION: 'Документація',
  AUTOMATIC_AML_STOP_FOR_ALL_DOCS_DESCRIPTION:
    'Ця дія обмежить автоматичні перевірки AML документами з машинозчитуваними зонами (MRZ), оптимізуючи час обробки, забезпечуючи моніторинг ключових документів. Будь ласка, підтвердьте ваше рішення.',
  AUTOMATIC_AML_START_FOR_ALL_DOCS_TOOLTIP:
    'Якщо автоматичний запуск AML вимкнено, перевірки AML виконуватимуться лише для документів, що містять MRZ дані.',
  AUTOMATIC_AML_STOP_FOR_ALL_DOCS_TITLE: 'Вимкнути автоматичний запуск AML для всіх документів?',
  ENABLE_AUTOMATIC_AML_START_FOR_ALL_DOCS: 'Увімкнути автоматичний запуск AML для всіх документів',
  AUTOMATIC_AML_START_FOR_ALL_DOCS_TITLE: 'Увімкнути автоматичний запуск AML для всіх типів документів?',
  AUTOMATIC_AML_START_FOR_ALL_DOCS_DESCRIPTION:
    'Ця дія ініціює перевірки AML для кожного поданого документа, незалежно від типу документа. Це може збільшити час обробки та використання ресурсів. Будь ласка, підтвердьте ваше рішення.',
  MONITORING_PERIODICITY: 'Періодичність моніторингу',
  YES_TURN_ON: 'Так, увімкнути',
  AUTO_APPROVAL: 'Автоматичне затвердження',
  AUTO_APPROVAL_DESCRIPTION:
    'Дозволяє системі автоматично затверджувати або відхиляти кроки верифікації без вашого втручання.',
  AUTO_APPROVAL_DIALOG_TITLE: 'Підтвердити активацію автоматичного затвердження',
  AUTO_APPROVAL_DIALOG_DESCRIPTION:
    'Увімкнувши автоматичне затвердження, всі кроки верифікації будуть автоматично оброблятися системою, що виключає необхідність ручного перегляду. Ви хочете продовжити цю дію?',

  // PERIODICITY
  DAILY: 'Щодня',
  WEEKLY: 'Один раз на тиждень',
  MONTHLY: 'Один раз на місяць',
  QUARTERLY: 'Щоквартально',
  HALF_EARLY: 'На половину раніше',
  YEARLY: 'Щороку',

  // STYLES
  FONT_FAMILY: 'Сімейство шрифтів',
  BACKGROUND_COLOR: 'Колір фону',
  TEXT_COLOR: 'Колір тексту',
  BORDER_COLOR: 'Колір межі',
  HOVER_BACKGROUND_COLOR: 'Колір фону при наведенні',
  HOVER_TEXT_COLOR: 'Колір тексту при наведенні',

  DESKTOP: 'Робочий стіл',
  LIGHT_THEME: 'Світла тема',
  DARK_THEME: 'Темна тема',
  ADD_NEW: 'Додати новий',
  ADD_STEP: 'Додати крок',
  WORKFLOW: 'Робочий процес',
  DOC_PHOTO: 'Фото документа',
  YES_DELETE: 'Так, видалити',
  WORKFLOWS: 'Робочі процеси',
  SELECT_ACTIONS: 'Виберіть дії',
  PREVIEW: 'Попередній перегляд',
  PHONE_CAMERA: 'Камера телефону',
  THANK_YOU_SCREEN: 'Екран подяки',
  QUESTIONNAIRE_STEP: 'Крок опитування',
  INTRO_SCREEN: 'Початковий екран',
  SEARCH_BY_NAME: 'Пошук за назвою',
  DELIVERY_METHOD: 'Спосіб доставки',
  TYPE_OF_DOCUMENTS: 'Тип документів',
  DESCRIPTION: 'Опис',
  NUMBER_OF_ATTEMPTS: 'Кількість спроб',
  URL_IS_NOT_VALID: 'Url не є дійсним',
  LIVENESS_CHECK: 'Перевірка liveness',
  FACE_MATCHING: 'Співставлення облич',
  OTP_VERIFICATION: 'Підтвердження OTP',
  BACK_TO_LIST: 'Повернутися до списку',
  AUTO_CAPTURE: 'Автоматичне захоплення',
  LIVENESS_RESULT: 'Результати liveness',
  QUESTIONNAIRE_SCHEMA: 'Схема опитування',
  DOCUMENT_CHECK: 'Перевірка документів',
  PERMITTED_COUNTRIES: 'Дозволені країни',
  CAPTURING_DOCS: 'Захоплення документів',
  GALLERY_UPLOAD: 'Завантаження з галереї',
  EXTERNAL_DATABASE: 'Зовнішня база даних',
  START_WORKFLOW: 'Запустити робочий процес',
  ENTER_COUNTRY_NAME: 'Введіть назву країни',
  DELETE_WORKFLOW: 'Видалити робочий процес',
  DELETE_DRAFT_WORKFLOW: 'Видалити чорновий робочий процес',
  URL_OF_THIS_DATABASE: 'URL цієї бази даних',
  EXCLUSION_COUNTRIES: 'Країни для виключення',
  ENTER_DOCUMENT_TYPE: 'Введіть тип документа',
  DUPLICATE_WORKFLOW: 'Дублювати робочий процес',
  ADD_NEW_WORKFLOW: 'Додати новий робочий процес',
  TYPE_OF_LIVENESS_CHECK: 'Тип перевірки liveness',
  SELFIE_WITH_DOCUMENT: 'Селфі з документом',
  ADD_PERMITTED_COUNTRIES: 'Додати дозволені країни',
  FLOW_SUCCESSFULLY_CREATED: 'Робочий процес успішно створено',
  FLOW_SUCCESSFULLY_UPDATED: 'Робочий процес успішно оновлено',
  NO_ADDITIONAL_CONFIGS: 'Немає додаткових налаштувань',
  ADD_EXCLUSION_COUNTRIES: 'Додати країни для виключення',
  SOURCE_FOR_FACE_MATCHING: 'Джерело для перевірки облич',
  SELECT_FLOW_STATUS: 'Виберіть статус повторюваного робочого процесу',
  CONFIRM_FLOW_DELETE: 'Ви впевнені, що хочете видалити робочий процес?',
  CONFIRM_DRAFT_FLOW_DELETE: 'Ви впевнені, що хочете видалити чорновий робочий процес?',

  INFO_STYLES_APPLY_TO_ALL_STEPS: 'Ці стилі застосуються до всіх кроків',

  QUESTIONNAIRE_SCHEMA_IS_REQUIRED: 'Необхідна схема анкети',
  MAX_NAME_LENGTH: 'Назва має містити не більше 50 символів',
  NAME_REQUIRED_FIELD: 'Назва обов`язкове для заповнення',
  NOT_ALL_REQUIRED_FIELDS_FILLED: 'Ви не заповнили всі необхідні поля',
  NAME_UNIQ_ERROR: 'Ця назва робочого процесу <strong>{{name}}</strong> уже існує',
  FACE_MATCH_ERROR_TOOLTIP:
    'Для можливості редагування цього поля, переконайтеся, що крок "Face Match" розташований після кроку <strong>{{stepName}}</strong>.',
  FACE_MATCH_ERROR_LENGTH: 'Потрібно вибрати принаймні 2 елементи!',
  CONTINUE: 'Продовжити',
  CLEAR_COUNTRIES_TITLE: 'Очистити список вибраних країн?',
  CLEAR_EXCLUSION_COUNTRIES_TEXT:
    'Ви впевнені, що хочете видалити всі вибрані країни зі списку винятків? Увесь список буде очищено.',
  CLEAR_PERMITTED_COUNTRIES_TEXT:
    'Ви впевнені, що хочете видалити всі вибрані країни зі списку дозволених? Увесь список буде очищено.',
  DOCUMENTS_POPPER_CONFIRM_TEXT:
    'Ви впевнені, що хочете видалити всі елементи у полі <strong>{{infoText}}</strong>?',
  TOOLTIP_FONT_FAMILY: 'Просто вставте шрифт Google у вказаному форматі, щоб застосувати обраний стиль.',

  // GENERAL TAB
  COUNTRIES_HINT: 'Set country-based restrictions using IP addresses',

  // LIVENESS
  SELFIE_TOOLTIP: 'Коротке селфі-відео (близько 0,7 с). Користувачу нічого не потрібно робити.',
  CUSTOM_3D_TOOLTIP: ' Поєднуйте різні дії (наприклад, рух очей, усмішку) для більш надійної перевірки.',
  LIVENESS_3D_TOOLTIP: 'Розширена верифікація за допомогою технології 3D-зображення.',

  // VALIDATION ERRORS
  DOC_SCAN_SHOULD_BE_ADDED: 'Для продовження, будь ласка, додайте скан документу.',
  AT_LEAST_ONE_SERVICE_SHOULD_BE:
    'Будь ласка, додайте хоча б один сервіс верифікації, перед тим як зберегти флоу.',

  // DOCUMENT SETTINGS
  MINIMAL_HOLDER_AGE: 'Мінімальний вік власника (у роках)',
  MINIMAL_HOLDER_AGE_TOOLTIP: 'Вкажіть мінімальний вік власника документа (у роках)',
  SHIFT_EXPIRY_DATE: 'Зсув дати закінчення терміну дії (в місяцях)',
  SHIFT_EXPIRY_DATE_TOOLTIP:
    'Зсув дати закінчення терміну дії в майбутнє або минуле на задану кількість місяців',
  FOCUS_CHECK: 'Перевірка фокусу під час перевірки якості зображення',
  FOCUS_CHECK_TOOLTIP: 'Вимкнути / увімкнути перевірку фокусу під час перевірки якості зображення',
  GLARES_CHECK: 'Перевірка відблисків під час перевірки якості зображення',
  GLARES_CHECK_TOOLTIP: 'Вимкнути / увімкнути перевірку відблисків під час перевірки якості зображення',
  COLORNESS_CHECK: 'Перевірка кольоровості під час перевірки якості зображення',
  COLORNESS_CHECK_TOOLTIP: 'Вимкнути / увімкнути перевірку кольоровості під час перевірки якості зображення',
  DOCUMENT_MINIMUM_INDENT: 'Мінімальний відступ документа',
  DOCUMENT_MINIMUM_INDENT_TOOLTIP:
    'Вкажіть мінімальний відступ (у відсотках від ширини документа) від кутів документа до меж зображення. Якщо кути документа ближчі, ніж вказане значення, статус міститиме помилку в полі documentPosition.',

  PROOF_OF_ADDRESS: 'Перевірка адреси',
  PROOF_OF_ADDRESS_DEPENDENCY_ERROR:
    'Додайте крок Документ або увімкніть «Брати дані з опитувальника» та додайте крок Опитувальник для перевірки адреси.',
  PROOF_OF_ADDRESS_DOCUMENT_REQUIRED: 'Додайте крок Документ перед перевіркою адреси.',
  PROOF_OF_ADDRESS_QUESTIONNAIRE_REQUIRED:
    'Увімкніть «Імпортувати ім’я з анкети» і додайте крок Опитувальник перед перевіркою адреси.',
  TAKE_DATA_FROM_DOCUMENT_WITHOUT_MRZ: 'Брати дані з документа без MRZ',
  TAKE_DATA_FROM_DOCUMENT_WITHOUT_MRZ_TOOLTIP:
    "Використовувати дані документа навіть якщо MRZ відсутній чи не зчитаний. Вмикайте лише якщо MRZ необов'язковий для вашого процесу.",
  UNIQ_FACE_MATCH_SOURCE_REQUIRED:
    'Для унікального зіставлення облич потрібні Документи, Зіставлення облич або Активність.',
  // EMPTY STATE
  EMPTY_STATE_DESCRIPTION:
    'Робочі процеси недоступні. Створіть власні верифікаційні процеси для управління етапами верифікації заявників.',
  UNIQ_FACE_MATCH: 'Унікальное зіставлення облич',
  // OTP
  SMS_MESSAGE: 'SMS-повідомлення',
  PHONE_CALL: 'Телефонний дзвінок',
  CHOOSE_OTP_DELIVERY_METHOD: 'Виберіть спосіб надсилання OTP',
  HLR: 'HLR (реєстрація місцезнаходження будинку)',
  HLR_TOOLTIP:
    'Коли HLR увімкнено, система перевіряє актуальний статус номера телефону без надсилання OTP. Якщо ви вимкнете цей параметр, вам потрібно буде увімкнути OTP для верифікації.',
  ONE_TIME_PASSWORD: 'OTP (одноразовий пароль)',
  EMAIL_VERIFICATION_TOOLTIP:
    'Коли OTP увімкнено, користувачі отримають унікальний код для підтвердження своєї електронної адреси. ',
  PHONE_VERIFICATION_TOOLTIP:
    'Коли OTP увімкнено, користувачі отримають унікальний код для підтвердження свого номера телефону. Вимкнення цього параметра потребує увімкнення HLR.',

  // TRANSACTION_MONITORING
  CRYPTOCURRENCY: 'Криптовалюта',
  TRANSACTION_MONITORING: 'Моніторинг транзакцій',

  // STEPS GROUPS
  COMPLIANCE_CHECKS: 'Перевірки відповідності',
  COMPLIANCE_CHECKS_DESCRIPTION: 'Кроки для забезпечення нормативної відповідності.',
  CONTACT_INFORMATION: 'Контактна інформація',
  CONTACT_INFORMATION_DESCRIPTION: 'Кроки для перевірки ваших контактних даних.',
  IDENTITY_VERIFICATION: 'Підтвердження особи',
  IDENTITY_VERIFICATION_DESCRIPTION: 'Кроки, що підтверджують особу користувача',
  ONBOARDING_AND_COMPLETION: 'Онбординг та завершення',
  ONBOARDING_AND_COMPLETION_DESCRIPTION: 'Початок та завершення процесу.',

  // transaction
  MAX_ADDRESS_COUNT: 'Максимальна кількість адрес',

  // INTRO
  ADD_YOUR_LINK: 'Додайте своє посилання',
  CONFIRMED_LINKS: 'Підтверджені посилання',
  INTRO_LINK_TITLE:
    'Тут ви можете додати персоналізовані посилання, з якими користувач повинен погодитися перед реєстрацією.',
  PRIVACY_POLICY_URL: 'Політика конфіденційності',
  TERMS_AND_CONDITIONS_URL: 'Правила та умови',
  PRIVACY_POLICY_LABEL: 'Посилання на політику конфіденційності',
  TERMS_AND_CONDITIONS_LABEL: 'Посилання на правила та умови',
  PRIVACY_POLICY_DESCRIPTION:
    'Підтверджуючи, ви заявляєте, що прочитали, зрозуміли та погоджуєтесь із <strong>політикою конфіденційності</strong>',
  TERMS_AND_CONDITIONS_DESCRIPTION:
    'Підтверджуючи, ви заявляєте, що прочитали, зрозуміли та погоджуєтесь із <strong>правилами та умовами</strong>',

  PERMITTED_BLOCKCHAINS: 'Дозволені блокчейни',
  ENTER_BLOCKCHAIN: 'Введіть блокчейн',
  AT_LEAST_ONE_BLOCKCHAIN: 'Необхідно додати принаймні один блокчейн.',

  DAY: 'день',
  WEEK: 'тиждень',
  MONTH: 'місяць',
  YEAR: 'рік',
  TIME_UNIT: 'Інтервал',
  DURATION_VALUE: 'Значення тривалості',
  ACTIVE_PERIOD: 'Термін дії верифікації',
  ACTIVE_PERIOD_TOOLTIP:
    'Виберіть дати, коли робочий процес буде активним. Якщо дати не вибрані, робочий процес буде активним постійно.',
  TAKE_DATA_FROM_QUESTIONNAIRE: 'Імпортувати ім’я з анкети',
  TAKE_DATA_FROM_QUESTIONNAIRE_TOOLTIP: 'Шукати ці поля в анкеті заявника.',

  PROOF_OF_ADDRESS_TITLE: 'Вимагати підтвердження адреси',
  PROOF_OF_ADDRESS_AUTO_DESCRIPTION: 'Автоматично перевіряти адреси користувачів за допомогою даних Google.',
  PROOF_OF_ADDRESS_ENABLE_DESCRIPTION:
    'Якщо ввімкнено, заявники повинні завантажити документ, що підтверджує їхню адресу.',
  PROOF_OF_ADDRESS_DOCUMENTS: 'Документи',
  EDIT_DOCUMENT: 'Редагувати документ',
};

export default locale;
